var map = {
	"./ABC.svg": "0c4d",
	"./Avanzar.svg": "713f",
	"./Flecha_lado.svg": "4939",
	"./Fondo_Menu_inferior.svg": "8d26",
	"./Fondo_Menu_inferior_optimo.svg": "6bd0",
	"./Fondo_Menu_inferior_optimo_alto.svg": "fcc1",
	"./Fondo_Titulo.svg": "3cea",
	"./Fondo_Titulo_Optimo.svg": "b316",
	"./Ginga.svg": "2fce",
	"./Logo_Completo_IBRACO.svg": "fce9",
	"./Logo_Simple_IBRACO_aaa.svg": "3bdd",
	"./Mapa_Vacio_Ids_Optimos.svg": "a047",
	"./Menu_Interfaz_basica/Abecedario.svg": "1177",
	"./Menu_Interfaz_basica/Abecedario_activo.svg": "7cf6",
	"./Menu_Interfaz_basica/Ajustes.svg": "ea93",
	"./Menu_Interfaz_basica/Ajustes_activo.svg": "76d3",
	"./Menu_Interfaz_basica/Creditos.svg": "895d",
	"./Menu_Interfaz_basica/Creditos_activo.svg": "3749",
	"./Menu_Interfaz_basica/Flecha_abajo.svg": "2ee7",
	"./Menu_Interfaz_basica/Glosario.svg": "6fc9",
	"./Menu_Interfaz_basica/Glosario_activo.svg": "11a3",
	"./Menu_Interfaz_basica/Menu_unidad.svg": "3b21",
	"./Menu_Interfaz_basica/Menu_unidade_Activo.svg": "791b",
	"./Presentación_personal.svg": "2892",
	"./Rectangulo_slider.svg": "ffff",
	"./Reproducir_sonido_Pequeño.svg": "69a6",
	"./Voltar.svg": "8448",
	"./bien.svg": "44a1",
	"./check.svg": "7b12",
	"./evaluacion-cerrar.svg": "b492",
	"./mal.svg": "2175",
	"./modalresult-avanzar.svg": "d3d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6353";